/**
 * Fetches a Daily.co meeting token for this client from the worker.
 * Mirrors the fetch style used by apps/web/src/deps/room/roomProxy/cloudRoomProxy.ts.
 */
export interface VideoTokenResult {
  dailyRoomUrl: string
  token: string
}

export async function fetchVideoToken(args: {
  workerUrl: string
  roomId: string
  clientId: string
}): Promise<VideoTokenResult> {
  const { workerUrl, roomId, clientId } = args
  const response = await fetch(`${workerUrl}/api/room/${encodeURIComponent(roomId)}/videoToken`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ clientId }),
  })
  if (!response.ok) {
    throw new Error(`Failed to fetch video token: ${response.status}`)
  }
  return response.json()
}
